import { showAddOrEditSaveViewDialog, hideAddOrEditSaveViewDialog } from '../actions/publicActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(showAddOrEditSaveViewDialog, actionMessage => {
    getStore().viewName = '';
    getStore().charmId = null;
    getStore().saveViewDialogShown = true;
    getStore().currentlyEditedView = actionMessage.saveCalendarViewConfig;
    if (getStore().currentlyEditedView) {
        getStore().viewName = getStore().currentlyEditedView.viewName;
        getStore().charmId = parseInt(getStore().currentlyEditedView.viewIcon);
    }
});

mutator(hideAddOrEditSaveViewDialog, actionMessage => {
    getStore().saveViewDialogShown = false;
});
